import './hit_details.css';
import React, { useState, useEffect } from "react";
import { Button } from '@mui/material';

import { ADD_HIT, GET_ADDRESS_BY_PINCODE, authKey, GET_ALL_BLOCKLIST_AND_REVENUECIRCLE } from '../../../../common/URLs';
import { useNavigate } from 'react-router-dom';
import { ADDRESS_ERROR, APPLICANT_ERROR, BLOCK_LIST, CONTACT_PERSON_FIRST_NAME_ERROR, GENDER, MOBILE_NO_ERROR, PINCODE_NO_ERROR, REVENUE_BLOCK_DEFAULT_VALUE, REVENUE_CIRCLE, SALUTATION, SEARCH_ICON_ERROR, VALID_NAME_OF_APPLICANT, VALID_NAME_OF_APPLICANT_ERROR, INVALID_OTP_ERROR, LINKS } from '../../../../common/constants';
import { CommonPincodeMUI } from '../../../../common/common-pincode/commonPincodeMUI';
import { loaderService } from '../../../../common/custom-loader/loader-service';
import { isValidName, maxNameLength, VALIDATION, nameValidation, typeNumberValid, emailValidation, emailUrnPassMaxLength } from '../../../../common/commonValidations';
import resolveIcon from "../../../../images/resolved.png";
import { sendOTP, validateOTP } from '../../../../common/Utils';
import jwt from 'jwt-decode';
import { getLocalStorageItem } from '../../../../common/localStorageUtils';
import { PROD } from '../../../../common/constants';
import { Container, Card, CardContent, ToggleButton, ToggleButtonGroup, FormGroup, FormControlLabel, Checkbox, Stack, Box, Typography, Grid, FormHelperText, FormControl, InputLabel, Select, MenuItem, TextField } from '@mui/material';
import BackButton from '../../../../common/backButton';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
import { ConfirmationPopover } from '../../../../common/commonPopovers/confirmationPopover';
import { PreRegPopover } from '../../../../common/commonPopovers/preRegPopver';
import { handleNumberFieldFocus } from '../../../../common/commonFunction';
import { CloseIcon, SubmitIcon } from '../../../../common/icons';
import BadgeComponent from '../../../../common/badge';
import { addressMaxLength, mobileNoMaxLength, totalClumpsMaxLength, mobileNumberValidation, otpMaxLength, pincodeValidation, plotValidationForKatha, plotValidationForOtherUnits, totalNumberOfClumpValidation, totalPlotsMaxLength} from '../../../../common/commonValidations';
import apiClient from '../../../../axios';


const HitDetails = () => {
    const { t, i18n } = useTranslation();
    const [mobileOTPValidated, setMobileOTPValidated] = useState(false);
    const [otpHidden, setOtpHidden] = useState(true);
    const [verifyMobileNo, setVerifyMobileNo] = useState(false);
    const [selectedApplicant, setSelectedApplicant] = useState('Individual');
    const decoded = getLocalStorageItem('id_token') ? (getLocalStorageItem('id_token') == "PreReg") ? null : jwt(getLocalStorageItem('id_token')) : null;
    const initialData = {
        fullName: '',
        mobileNo: '',
        emailId: '',
        companyType: '',
        pincode: '',
        contactPersonFirstName: '',
        contactPersonMiddleName: '',
        contactPersonLastName: '',
        contactPersonSalutation: SALUTATION[0],
        contactPersonGender: GENDER[0],
        revenueCircle: '',
        blockName: '',
        emailId: '',
    };
    const [details, setDetails] = useState(initialData);
    const navigate = useNavigate();
    const [hitDetails, sethitDetails] = useState();
    const [hitError, setHitError] = useState('');
    const [otpValue, setOtpValue] = useState()
    const [logModalOpenConfirm, setLogModalOpenConfirm] = useState(false);
    const handleLogModalConfirmOpen = () => setLogModalOpenConfirm(true);
    const handleLogModalConfirmClose = () => setLogModalOpenConfirm(false);
    const [logModalOpenSuccess, setLogModalOpenSuccess] = useState(false);
    const handleLogModalSuccessOpen = () => setLogModalOpenSuccess(true);
    const handleLogModalSuccessClose = () => setLogModalOpenSuccess(false);
    const [checkTermChecked, setCheckTermChecked] = useState(false);
    const [checkTermDisable, setCheckTermDisable] = useState(false);
    const initialError = {
        fullNameError: '',
        contactPersonNameError: '',
        mobileNoError: '',
        pincodeError: '',
        searchError: '',
        addressError: '',
        acceptTermError: '',
        emailIdError: ''
    };
    const [errorMessage, setErrorMessage] = useState(initialError);
    const clear = (e) => {
        setDetails(initialData);
        setMobileOTPValidated(false);
        setCheckTermChecked(false);
        setCheckTermDisable(false);
        setOtpHidden(true);
        setVerifyMobileNo(false);
        sethitDetails();
        setErrorMessage(initialError);
    }
    const handleCheckboxTerms = (e) => {
        if (e.target.checked) {
            e.preventDefault();
            setErrorMessage({ ...errorMessage, OTPError: "" });
            setOtpValue("");
            if (isValidMobileNumber(details.mobileNo)) {
                sendOTP(details.mobileNo, callBackMobileValidation);
                setErrorMessage({ ...errorMessage, mobileNoError: "", acceptTermError: "" });
                setCheckTermChecked(true);
                setCheckTermDisable(true);
            }
            else {
                setErrorMessage({ ...errorMessage, mobileNoError: MOBILE_NO_ERROR });
                setCheckTermChecked(false);
            }
        }
    }
    const onClickVerifyMobileNo = (e) => {
        e.preventDefault();
        setErrorMessage({ ...errorMessage, OTPError: "" });
        setOtpValue("");
        if (isValidMobileNumber(details.mobileNo)) {
            sendOTP(details.mobileNo, callBackMobileValidation);
            setErrorMessage({ ...errorMessage, mobileNoError: "" });
        }
        else
            setErrorMessage({ ...errorMessage, mobileNoError: MOBILE_NO_ERROR });
    }
    const callBackMobileValidation = (response) => {
        if (response.isSuccess) {
            setErrorMessage({ ...errorMessage, OTPSentError: "", mobileNoError: "", OTPError: "", acceptTermError: ""  })
            setVerifyMobileNo(true);
            setOtpHidden(false);
        }

    }
    const onOtpChange = (e) => {
        const limit = 6;
        setOtpValue(e.target.value.slice(0, limit))
        if (e.target.value.length == 6) {
            validateOTP(details.mobileNo, e.target.value, callBackOTPValidation);
        }
    }
    const callBackOTPValidation = (response) => {
        setErrorMessage({ ...errorMessage, OTPSentError: "", mobileNoError: "", acceptTermError :""});
        if (response.isSuccess === true) {
            setVerifyMobileNo(false);
            setOtpHidden(true);
            setMobileOTPValidated(true);
        }
        else {
            setErrorMessage({ ...errorMessage, mobileNoError: INVALID_OTP_ERROR });
        }
    }
    const isValidMobileNumber = (mobileNo) => {
        if (mobileNo.length == 10) {
            return true;
        }
        return false;
    }
    useEffect(() => {
        if (hitDetails) {
            if (hitDetails.isSuccess) {
                handleLogModalSuccessOpen();
            }
            else {
                if (hitDetails.message) {
                    toast.error(hitDetails.message);
                } else
                    toast.error("HIT creation failed");
            }
        }
        
    }, [hitDetails]);

    const handleChange = (e) => {

  if (e.target.name === "fullName") {

    // 1) Clean + limit:

    const cleanedValue = e.target.value.replace(/[^a-zA-Z0-9&/ ]/g, "").slice(0, 100);

    // 2) Save cleaned value only once:

    setDetails({

      ...details,

      [e.target.name]: cleanedValue

    });

    // 3) Validate cleaned value:

    if (cleanedValue.length > 0) {

      const Fullname_regex = /^[a-zA-Z0-9 ]+$/;

      if (!Fullname_regex.test(cleanedValue)) {

        setErrorMessage({

          ...errorMessage,

          fullNameError: "Please provide valid Name"

        });

      } else {

        setErrorMessage({

          ...errorMessage,

          fullNameError: ""

        });

      }

    } else {

      setErrorMessage({

        ...errorMessage,

        fullNameError: "Please enter Name of Applicant"

      });

    }

  } else {

    // For other fields, normal update:

    setDetails({

      ...details,

      [e.target.name]: e.target.value

    });

  }

        if (e.target.name === "emailId") {
            if ((e.target.value).length > 0) {
                if (emailValidation(e.target.value.slice(0, 50))) {
                    setErrorMessage({ ...errorMessage, emailIdError: "" })
                } else setErrorMessage({ ...errorMessage, emailIdError: "Please enter valid email" })
            } else setErrorMessage({ ...errorMessage, emailIdError: "Please enter Email Address" })
        }
        if (e.target.name === "address") {
            var limit = 300;
            if ((e.target.value).length > 0) {
                setDetails({ ...details, [e.target.name]: VALIDATION.noSpecialCharacterValidation(e.target.value.slice(0, limit)) })
                setErrorMessage({ ...errorMessage, addressError: "" })
            } else setErrorMessage({ ...errorMessage, addressError: ADDRESS_ERROR })
        }
        if (e.target.name === "contactPersonFirstName") {
            if ((e.target.value).length > 0) {
                setDetails({ ...details, [e.target.name]: nameValidation(e.target.value)})
                if (isValidName(e.target.value)) {
                    setErrorMessage({ ...errorMessage, contactPersonNameError: "" })
                } else setErrorMessage({ ...errorMessage, contactPersonNameError: "Please enter valid name of contact person" })
            } else {
                setErrorMessage({ ...errorMessage, contactPersonNameError: CONTACT_PERSON_FIRST_NAME_ERROR })

            }
        }
        if (e.target.name === "contactPersonMiddleName") {
            if ((e.target.value).length > 0) {
                setDetails({ ...details, [e.target.name]: nameValidation(e.target.value)})
            } else return
        }
        if (e.target.name === "contactPersonLastName") {
            if ((e.target.value).length > 0) {
                setDetails({ ...details, [e.target.name]: nameValidation(e.target.value)})
            } else return
        }
        if (e.target.name === "mobileNo") {
            const limit = 10;
            setDetails({ ...details, [e.target.name]: e.target.value.slice(0, limit) })
            if ((e.target.value).length < 10) {
                setErrorMessage({ ...errorMessage, mobileNoError: "Please enter 10 digit mobile number" });
            }
            else setErrorMessage({ ...errorMessage, mobileNoError: "" });

        }
        if (e.target.name === "pincode") {
            const limit = 6;
            setDetails({ ...details, [e.target.name]: e.target.value.slice(0, limit) })
            if ((e.target.value).length < 6) {
                setErrorMessage({ ...errorMessage, pincodeError: "Please enter 6 digit pincode" });
            }
            else setErrorMessage({ ...errorMessage, pincodeError: "" });
        }
    };
    const validateDetails = () => {
        if ((!details.fullName)) {
            setErrorMessage({ ...errorMessage, fullNameError: APPLICANT_ERROR });
            return false;
        } else if (!details.contactPersonFirstName) {
            setErrorMessage({ ...errorMessage, contactPersonNameError: CONTACT_PERSON_FIRST_NAME_ERROR });
            return false;
        }
        else if (!details.mobileNo) {
            setErrorMessage({ ...errorMessage, mobileNoError: MOBILE_NO_ERROR });
            return false;
        }
        else if (!details.address) {
            setErrorMessage({ ...errorMessage, addressError: ADDRESS_ERROR });
            return false;
        }
        else if (!details.emailId) {
            setErrorMessage({ ...errorMessage, emailIdError: "Please enter email address" });
            return false;
        }
        else if ((details.pincode).length < 6) {
            setErrorMessage({ ...errorMessage, pincodeError: PINCODE_NO_ERROR });
            return false;
        }
        else if (!details.state) {
            setErrorMessage({ ...errorMessage, searchError: SEARCH_ICON_ERROR });
            return false;
        }
        else if (!checkTermChecked) {
            setErrorMessage({ ...errorMessage, acceptTermError: "Please accept the Privacy Policy and Terms of Use of ABEPL." });
            return false;
        }
        else if (!mobileOTPValidated && verifyMobileNo) {
            setErrorMessage({ ...errorMessage, acceptTermError: "Please enter the OTP sent to your mobile number" });
            return false;
        }
        return true;
    }

    const submitHitDetails = () => {
        handleLogModalConfirmClose();
        loaderService.showLoader()
        let headers = {
            AuthKey: authKey,
        }
        if (getLocalStorageItem('id_token')) {
            headers = {
                AuthKey: authKey,
                Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
            }
        }
        apiClient.post(ADD_HIT,
            {
                "applicantType": selectedApplicant,
                "name": details.fullName,
                "contactPersonName": details.contactPersonFirstName,
                "contactPersonFirstname": details.contactPersonFirstName,
                "contactPersonMiddlename": details.contactPersonMiddleName,
                "contactPersonLastname": details.contactPersonLastName,
                "contactPersonGender": details.contactPersonGender,
                "contactPersonSalutation": details.contactPersonSalutation,
                "mobileNo": details.mobileNo,
                "pincode": details.pincode,
                "address": details.address,
                "emailId": details.emailId,
                "state": details.state,
                "district": details.district,
                "subDivision": details?.subDivision,
                "revenueCircle": details.revenueCircle,
                "blockName": details.blockName,
                "otp": otpValue,
                "isOtpValidated": true,
                "acceptedTerms": checkTermChecked
            },
            {
                headers: headers
            }
        )
            .then((response) => {
                if (!response.data.isSuccess && response.data.message.indexOf("mobile number") >= 0) {
                    setVerifyMobileNo(false);
                    setMobileOTPValidated(false);
                    setCheckTermChecked(false);
                    setCheckTermDisable(false);
                }
                sethitDetails(response.data);
                loaderService.hideLoader()
            })
            .catch(function (error) {
                setHitError(error);
                loaderService.hideLoader()
            });
    }
    const onApplicantClick = (e) => {
        e.preventDefault();
        setSelectedApplicant(e.target.value)
        // if (applicantSelected === 'Individual') {
        //     setSelectedApplicant('Individual')
        // } else if (applicantSelected === 'Partnership') {
        //     setSelectedApplicant('Partnership')
        // } else if (applicantSelected === 'Proprietorship') {
        //     setSelectedApplicant('Proprietorship')
        // } else if (applicantSelected === 'Private') {
        //     setSelectedApplicant('Private')
        // }
    }
    const getUpdatedAddressData = (data) => {
        setDetails({
            ...details,
            pincode: data.pincode,
            state: data.pincodeState,
            district: data.pincodeDistrict,
            subDivision: data.pincodeSubDivision,
            revenueCircle: data.selectedRevenueCircle,
            blockName: data.selectedBlockName,

        })
    }
    const handleChangeSelect = (e, type) => {
        if (type == BLOCK_LIST) {
            setDetails({ ...details, blockName: e.target.value });
        }
        if (type == REVENUE_CIRCLE) {
            setDetails({ ...details, revenueCircle: e.target.value, });
        }
    }
    const confirmSubmission = (e) => {
        if (validateDetails()) {
            handleLogModalConfirmOpen();
        }
    }
    return (
        <>
            <Container maxWidth="xxl">
            {!PROD && <p style={{ textAlign: "right", fontSize: "2vh" }}>REG03</p>}
                <Stack direction="row" alignItems="center" spacing={1} mb={1}>
                    <BackButton navigate={navigate} />
                    <Typography variant="h5" gutterBottom>
                       {t('preReg.hit')}{t('preReg.r')} {t('preReg.pre-registration')}
                    </Typography>
                </Stack>
                <Card>
                    <CardContent>
                        <Typography variant="subtitle2" gutterBottom>
                            {t('preReg.applicantType')}
                        </Typography>
                        <ToggleButtonGroup style={{ display: "flex", overflow: "auto" }}
                            color="primary"
                            value={selectedApplicant}
                            exclusive
                            onChange={(e) => onApplicantClick(e)}
                            aria-label="Platform"
                        >
                            <ToggleButton value="Individual">{t('preReg.individual')}</ToggleButton>
                            <ToggleButton value="Partnership">{t('preReg.partnership')}</ToggleButton>
                            <ToggleButton value="Proprietorship">{t('preReg.proprietorship')}</ToggleButton>
                            <ToggleButton value="Company">{t('preReg.company')}</ToggleButton>
                        </ToggleButtonGroup>
                        <Grid container spacing={2} direction="row" mt={1}>
                            <Grid item xs={12} lg={6}>
                                <Grid container spacing={1}>
                                    <Grid item xs={12}>
                                        <TextField fullWidth
                                            required
                                            error={errorMessage.fullNameError}
                                            helperText={errorMessage.fullNameError}
                                            type="text"
                                            label={t('preReg.applicantName')}
                                            inputProps={{
                                                maxLength: maxNameLength
                                            }} 
                                            name="fullName"
                                            value={details.fullName}
                                            onChange={(e) => handleChange(e)}
                                            onKeyDown={(evt) => { evt.key === 'Enter' && evt.preventDefault() }} />
                                            <BadgeComponent currentLength={details?.fullName?.length} maxLength={maxNameLength} />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <Typography variant="h6" style={{ marginBottom: "1em" }} gutterBottom>
                                            {t('preReg.contactPersonDetails')}
                                        </Typography>
                                    </Grid>

                                    <Grid item xs={3}>
                                        <FormControl fullWidth>
                                            <InputLabel>{t('preReg.salutation')}</InputLabel>
                                            <Select
                                                label={t('preReg.salutation')}
                                                name='contactPersonSalutation'
                                                value={details.contactPersonSalutation}
                                                onChange={(e) => handleChange(e)}
                                                onKeyDown={(evt) => { evt.key === 'Enter' && evt.preventDefault() }}>
                                                {SALUTATION.map((item) => <MenuItem key={item} value={item}>{item}</MenuItem>)}
                                            </Select>
                                            {/* <FormHelperText sx={{ color: 'red' }}>{errorMessage?.categoryError}</FormHelperText> */}
                                        </FormControl>
                                    </Grid>
                                    <Grid item xs={9}>
                                        <TextField fullWidth
                                            required
                                            error={errorMessage.contactPersonNameError}
                                            helperText={errorMessage.contactPersonNameError}
                                            type="text"
                                            inputProps={{
                                                maxLength: maxNameLength
                                            }}
                                            label={t('preReg.firstname')}
                                            name="contactPersonFirstName"
                                            value={details.contactPersonFirstName}
                                            onChange={(e) => handleChange(e)}
                                            onKeyDown={(evt) => { evt.key === 'Enter' && evt.preventDefault() }} />
                                            <BadgeComponent currentLength={details?.contactPersonFirstName?.length} maxLength={maxNameLength} />
                                    </Grid>
                                    <Grid item xs={6}>
                                        <TextField fullWidth
                                            type="text"
                                            inputProps={{
                                                maxLength: maxNameLength
                                            }}
                                            label={t('preReg.middlename')}
                                            name="contactPersonMiddleName"
                                            value={details.contactPersonMiddleName}
                                            onChange={(e) => handleChange(e)}
                                            onKeyDown={(evt) => { evt.key === 'Enter' && evt.preventDefault() }} />
                                            <BadgeComponent currentLength={details?.contactPersonMiddleName?.length} maxLength={maxNameLength} />
                                    </Grid>
                                    <Grid item xs={6}>
                                        <TextField fullWidth
                                            type="text"
                                            inputProps={{
                                                maxLength: maxNameLength
                                            }}
                                            label={t('preReg.lastname')}
                                            name="contactPersonLastName"
                                            value={details.contactPersonLastName}
                                            onChange={(e) => handleChange(e)}
                                            onKeyDown={(evt) => { evt.key === 'Enter' && evt.preventDefault() }} />
                                            <BadgeComponent currentLength={details?.contactPersonLastName?.length} maxLength={maxNameLength} />
                                    </Grid>
                                    <Grid item xs={3}>
                                        <FormControl fullWidth>
                                            <InputLabel>{t('preReg.gender')}</InputLabel>
                                            <Select
                                                label={t('preReg.gender')}
                                                name='contactPersonGender'
                                                value={details.contactPersonGender}
                                                onChange={(e) => handleChange(e)}
                                                onKeyDown={(evt) => { evt.key === 'Enter' && evt.preventDefault() }}>
                                                {GENDER.map((item) => <MenuItem key={item} value={item}>{item}</MenuItem>)}
                                            </Select>
                                        </FormControl>
                                    </Grid>
                                    <Grid item xs={9}>
                                        <TextField fullWidth
                                            required
                                            error={errorMessage.mobileNoError}
                                            helperText={errorMessage.mobileNoError}
                                            type="number"
                                            onFocus={handleNumberFieldFocus}
                                            label={t('preReg.mobileNo')}
                                            name="mobileNo"
                                            value={details.mobileNo}
                                            onChange={(e) => handleChange(e)}
                                            onKeyDown={(evt) => (evt.key === 'e' || evt.key === 'E' || evt.key === '.' || evt.key === '-' || evt.key === "Enter") && evt.preventDefault()}
                                            disabled={mobileOTPValidated} />
                                            <BadgeComponent currentLength={details?.mobileNo?.length} maxLength={mobileNoMaxLength} />
                                        {mobileOTPValidated === true && <div className="commonVerifyText" hidden={!mobileOTPValidated}><a href="#">Verified</a>
                                            <img className="commonOtpImg" src={resolveIcon} alt="" /></div>}
                                    </Grid>
                                    {/*{verifyMobileNo &&*/}
                                    {/*    <Grid item xs={3}>*/}
                                    {/*        <TextField*/}
                                    {/*            type="number"*/}
                                    {/*            onChange={(e) => onOtpChange(e)}*/}
                                    {/*            value={otpValue}*/}
                                    {/*            label={t('preReg.otp')}*/}
                                    {/*            onKeyDown={(evt) => (evt.key === 'e' || evt.key === 'E' || evt.key === '.' || evt.key === '-' || evt.key === "Enter") && evt.preventDefault()} />*/}
                                    {/*    </Grid>*/}
                                    {/*}*/}
                                    {/*<Grid item xs={12}>*/}
                                    {/*    {verifyMobileNo === true ?*/}
                                    {/*        <div>*/}
                                    {/*            <a href='#' className="commonVerifyText" onClick={(e) => onClickVerifyMobileNo(e)}>Resend otp</a></div>*/}
                                    {/*        : mobileOTPValidated === true ? <div className="commonVerifyText" hidden={!mobileOTPValidated} ><a href="#" style={{ marginLeft: "4vw" }}>Verified</a>*/}
                                    {/*            <img className="commonOtpImg" src={resolveIcon} alt="" /></div> :*/}
                                    {/*            <button className="commonVerifyText" style={{ marginLeft: "0vw", float: "right" }} onClick={(e) => onClickVerifyMobileNo(e)}>Verify Mobile no.</button>*/}
                                    {/*    }*/}
                                    {/*</Grid>*/}
                                </Grid>
                            </Grid>
                            <Grid item xs={12} lg={6}>
                                <Grid container spacing={1}>
                                <Grid item xs={12}>
                                        <TextField fullWidth
                                            required
                                            inputProps={{
                                                maxLength: emailUrnPassMaxLength,
                                                style: { textTransform: "none" }
                                            }}
                                            error={errorMessage.emailIdError}
                                            helperText={errorMessage.emailIdError}
                                            type="text"
                                            label={t('main.email')}
                                            name="emailId"
                                            value={details.emailId}
                                            onChange={(e) => handleChange(e)}
                                            onKeyDown={(evt) => { evt.key === 'Enter' && evt.preventDefault() }} />
                                            <BadgeComponent currentLength={details?.emailId?.length} maxLength={emailUrnPassMaxLength} />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <TextField fullWidth
                                            error={errorMessage?.addressError}
                                            helperText={errorMessage?.addressError}
                                            required
                                            type="text"
                                            label={t('main.officeAddressTitle')}
                                            name="address"
                                            value={details.address}
                                            multiline
                                            onChange={(e) => handleChange(e)}
                                            inputProps={{
                                                maxLength: 300
                                            }}
                                            onKeyDown={(evt) => { evt.key === 'Enter' && evt.preventDefault() }} />
                                            <BadgeComponent currentLength={details?.address?.length} maxLength={addressMaxLength} />
                                    </Grid>
                                    <CommonPincodeMUI setErrorMessage={setErrorMessage} 
                                    revenueNotRequired={true}
                                        pincode={details?.pincode}
                                        state={details?.state}
                                        district={details?.district}
                                        revenueCircle={details?.revenueCircle}
                                        blockName={details?.blockName}
                                        onHandleCallback={getUpdatedAddressData}
                                        pincodeError={errorMessage.pincodeError}
                                        searchError={errorMessage.searchError}
                                        handleChangeSelect={handleChangeSelect}
                                    />
                                </Grid>
                            </Grid>
                        </Grid>
                    </CardContent>
                </Card>
                <Grid container spacing={1}>
                    <Grid item xs={12}>
                        <FormGroup>
                            <FormControlLabel control={<Checkbox checked={checkTermChecked} onChange={(e) => handleCheckboxTerms(e)} disabled={checkTermDisable} />} label={<><label for="chkTerms"> I agree to the <a href={LINKS.PRIVACY_POLICY}>Privacy Policy</a> and <a href={LINKS.TERMS_OF_USE}>Terms of Use</a> of ABEPL.</label></>} ></FormControlLabel>
                        </FormGroup>
                        <div style={{ color: "#d32f2f", fontSize: "0.75 rem" }}>{errorMessage.acceptTermError}</div>
                    </Grid>
                    <Grid item xs={3}>
                        {verifyMobileNo &&

                            <TextField fullWidth
                                type="number"
                                onFocus={handleNumberFieldFocus}
                                onKeyDown={(evt) => typeNumberValid(evt)}
                                onChange={(e) => onOtpChange(e)}
                                label={t('preReg.otp')}
                                value={otpValue} />

                        }
                        {verifyMobileNo === true &&
                            <div>
                                <a href='#' className="commonVerifyText" onClick={(e) => onClickVerifyMobileNo(e)}>Resend OTP</a></div>
                        }
                    </Grid>
                </Grid>
                <Box display='flex' alignItems="center" justifyContent="center" mt={3} style={{ float: "right" }}>
                    <Button sx={{ minWidth: 100, marginRight: 1 }} variant="outlined" onClick={(e) => clear(e)} startIcon={<CloseIcon />}>{t('preReg.clear')}</Button>
                    <Button sx={{ minWidth: 100 }} disabled={!mobileOTPValidated} variant="contained" onClick={(e) => confirmSubmission(e)} endIcon={<SubmitIcon />}>{t('preReg.submit')}</Button>
                </Box>
            </Container>
            <ConfirmationPopover action="Submit" onOpen={logModalOpenConfirm} onConfirm={submitHitDetails} onClose={handleLogModalConfirmClose} />
                    <PreRegPopover onOpen={logModalOpenSuccess} onClose={handleLogModalSuccessClose} urn={hitDetails?.hitDetails?.regStakeholderMaster?.urn} message="HIT created successfully" navigate={navigate} navigatePath={decoded != null && decoded && decoded.emails && decoded.emails[0] ? '/registrationHome/dashboard' : '/'}/>
                </>
    );
}
export default HitDetails;
